




















import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import OohSetting from './oohSetting.vue';
@Component({
  components: {
    OohSetting,
  },
})
export default class TransportOrderSettingPage extends Vue {
  /** tab信息 */
  private tabList = [
    {
      value: 'ooh-setting',
      text: this.t('自提编码配置'),
      dataSign: 'transport_order_setting_tab_ooh',
    },
  ];
  /** 当前激活tab */
  private activeTab: string = this.tabList[0].value as string;
  @Watch('$route', { deep: true, immediate: true })
  private onRouteChange() {
    const activeTab = this.$route.params?.active;
    if (!this.$util.isEmpty(activeTab)) {
      this.activeTab = activeTab;
    }
  }
}
